import styled from "styled-components";
import {COLORS} from "../../../values/colors"

export const PageContainer = styled.div`
    background-color: ${COLORS.darkGray};
    color: ${COLORS.white};
`;

export const HeroBannerContainer = styled.div`
    margin-bottom: 2rem;
`;

export const TopicContainer = styled.div`
    text-align: center;
    margin-bottom: 3rem;
`;

export const ContentContainer = styled.div`    
`;